import { z } from 'zod'

import { SpotFrequencyMonthsEnum } from '@gto/api-client/admin/react-query'

import { rejectedValue, searchValueAsText } from '@/pages/analyzer-insights/search-rejection'

export const MONTHS_WINDOW_OPTIONS: readonly SpotFrequencyMonthsEnum[] =
  Object.values(SpotFrequencyMonthsEnum)

const validMonths = z.coerce.number().pipe(z.literal([...MONTHS_WINDOW_OPTIONS]))

export const analyzerInsightsSpotsSearchSchema = z.object({
  months: z.union([validMonths, rejectedValue]).optional().catch(undefined),
  site: z.union([z.string(), z.unknown().transform(searchValueAsText)]).optional(),
})

export type AnalyzerInsightsSpotsSearch = z.infer<typeof analyzerInsightsSpotsSearchSchema>
